export const SupplierTokenStyle = {
  Container: 'flex flex-col w-full h-[100vh] pt-28 items-center'
}